export default __webpack_public_path__ + "static/media/Reason 1.c37aff04.mp3";